/*
 * Оформление приложения. Выбор живёт на устройстве — рядом со свёрнутым меню
 * и привязкой пин-кода: на телефоне удобна тёмная, на рабочем ноуте светлая.
 * «Как в системе» — это отсутствие data-theme: тогда решает медиазапрос
 * prefers-color-scheme в styles.css.
 */
export type Theme = 'system' | 'light' | 'dark';

const KEY = 'code-theme';

const isTheme = (v: string | null): v is Theme => v === 'system' || v === 'light' || v === 'dark';

export const themeOf = (): Theme => {
  const saved = localStorage.getItem(KEY);
  return isTheme(saved) ? saved : 'system';
};

/** Переносит выбор в <html> — оттуда его читают переменные CSS. */
export function applyTheme(theme: Theme = themeOf()) {
  const root = document.documentElement;
  if (theme === 'system') root.removeAttribute('data-theme');
  else root.setAttribute('data-theme', theme);
}

export function setTheme(theme: Theme) {
  localStorage.setItem(KEY, theme);
  applyTheme(theme);
}
